import { Link } from 'react-router';

import { mergeClasses } from 'src/utils/merge-classes';

const VARIANT_CLASS = {
  blue: 'btn-blue',
  dawn: 'btn-dawn',
  ghost: 'btn-ghost',
  dayDark: 'btn-day-dark',
};

type ButtonVariant = keyof typeof VARIANT_CLASS;

type ButtonLinkProps = {
  to: string;
  label: string;
  variant: ButtonVariant;
  withArrow?: boolean;
};

export function ButtonLink({ to, label, variant, withArrow = false }: ButtonLinkProps) {
  return (
    <Link to={to} className={mergeClasses('btn', VARIANT_CLASS[variant])}>
      {label}
      {withArrow && <span className="arrow">→</span>}
    </Link>
  );
}
